__turbopack_context__.v({
  "container": "FaqWrap-module-scss-module__1qn1YG__container",
  "faqAnswer": "FaqWrap-module-scss-module__1qn1YG__faqAnswer",
  "faqAnswerContent": "FaqWrap-module-scss-module__1qn1YG__faqAnswerContent",
  "faqChevron": "FaqWrap-module-scss-module__1qn1YG__faqChevron",
  "faqItem": "FaqWrap-module-scss-module__1qn1YG__faqItem",
  "faqQuestion": "FaqWrap-module-scss-module__1qn1YG__faqQuestion",
  "fromCategories": "FaqWrap-module-scss-module__1qn1YG__fromCategories",
  "fullWidth": "FaqWrap-module-scss-module__1qn1YG__fullWidth",
  "headingWrapper": "FaqWrap-module-scss-module__1qn1YG__headingWrapper",
  "moreResults": "FaqWrap-module-scss-module__1qn1YG__moreResults",
  "moreResultsIcon": "FaqWrap-module-scss-module__1qn1YG__moreResultsIcon",
  "open": "FaqWrap-module-scss-module__1qn1YG__open",
  "sectionHeading": "FaqWrap-module-scss-module__1qn1YG__sectionHeading",
  "wrapper": "FaqWrap-module-scss-module__1qn1YG__wrapper",
});
